/* SHAHCOSMETICS theme — theme.js (no dependencies) */
(function () {
  'use strict';

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  /* Quantity steppers (product + cart) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var v = parseInt(input.value || '0', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: submit quantity changes automatically */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function () { cartForm.submit(); }, 450);
    });
  }

  /* Collection filters + sort: submit on change */
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    var t;
    form.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var params = new URLSearchParams(new FormData(form));
        Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
        window.location.search = params.toString();
      }, 300);
    });
  });

  /* Close open <details> dropdowns when clicking elsewhere */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.dropdown[open], details.search-pop[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[open].dropdown, details[open].search-pop, details[open].menu-drawer').forEach(function (d) { d.removeAttribute('open'); });
  });
  var sp = document.querySelector('.search-pop');
  if (sp) sp.addEventListener('toggle', function () { if (sp.open) { var i = sp.querySelector('input'); if (i) i.focus(); } });

  /* Product page */
  var section = document.querySelector('[data-product-section]');
  if (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var priceNow = section.querySelector('[data-price-now]');
    var priceWas = section.querySelector('[data-price-was]');
    var priceWrap = section.querySelector('[data-price]');

    function showMedia(id) {
      if (!id) return;
      section.querySelectorAll('.gallery__slide').forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId == id); });
      section.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb == id); });
    }
    section.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    function selectedOptions() {
      return Array.from(section.querySelectorAll('.variants__set')).map(function (set) {
        var c = set.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function updateAvailability(opts) {
      if (!product) return;
      section.querySelectorAll('.variants__set').forEach(function (set, idx) {
        set.querySelectorAll('input').forEach(function (input) {
          var trial = opts.slice(); trial[idx] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === idx || o === trial[i]; }) && v.options[idx] === input.value;
          });
          var label = set.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    section.addEventListener('change', function (e) {
      if (!e.target.closest('.variants') || !product) return;
      var set = e.target.closest('.variants__set');
      var out = set && set.querySelector('[data-option-value]');
      if (out) out.textContent = e.target.value;
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      updateAvailability(opts);
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      if (priceWas) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWas.hidden = !sale;
        if (sale) priceWas.textContent = formatMoney(variant.compare_at_price);
        if (priceWrap) priceWrap.classList.toggle('price--sale', !!sale);
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
    updateAvailability(selectedOptions());

    /* AJAX add to cart */
    var form = section.querySelector('[data-product-form]');
    var errorEl = section.querySelector('[data-form-error]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); }
        if (errorEl) errorEl.hidden = true;
        fetch(window.theme.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag.');
            return fetch(window.theme.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
              showNotification(res.data);
            });
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () {
            if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.disabled = false; }
          });
      });
    }
  }

  /* Cart notification */
  var note = document.getElementById('CartNotification');
  var noteTimer;
  function showNotification(item) {
    if (!note) return;
    var box = note.querySelector('[data-cart-note-item]');
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<br><span class="note">' + item.variant_title + '</span>' : '';
    box.innerHTML = img + '<div><strong>' + item.product_title + '</strong>' + variant + '<br>' + formatMoney(item.final_line_price || item.price) + '</div>';
    note.hidden = false;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { note.hidden = true; }, 6000);
  }
  if (note) note.querySelector('[data-cart-note-close]').addEventListener('click', function () { note.hidden = true; });

  /* Related products (loaded after page) */
  document.querySelectorAll('[data-related-url]').forEach(function (el) {
    fetch(el.dataset.relatedUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-related-url]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  });

  /* Customer login: show recover form */
  document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function () { var r = document.getElementById('Recover'); if (r) r.style.display = 'block'; });
  });

  /* Address forms: preselect saved country */
  document.querySelectorAll('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });
})();
